import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { Styles } from 'src/components/sections/HeroCarousel/hero-carousel'

type Props = {
  label: string
  styles?: Styles
  hasSameBgAsSlide: boolean
}

export const CTA = ({
  label,
  styles: { backgroundColor, bold, color, size } = {},
  hasSameBgAsSlide,
}: Props) => {
  const { isMobile } = useBreakpoint()

  const formatSize = (size: string | undefined, defaultSize: string) => {
    if (!size) return defaultSize
    // To verify if size is a string in this format "16px"
    const firstRegex = /^\d+px$/
    // To verify in size is a string with only numbers e.g. "16"
    const secondRegex = /^\d+$/

    if (firstRegex.test(size)) {
      return size
    } else if (secondRegex.test(size)) {
      return `${size}px`
    }
    return defaultSize
  }

  const getFontSize = () => {
    let fontSize = '16px'
    if (isMobile) {
      return (fontSize = formatSize(size?.mobile, '16px'))
    }
    return (fontSize = formatSize(size?.desktop, '20px'))
  }

  const fontSize = getFontSize()

  return (
    <span
      className={`font-semibold text-base md:text-xl mt-auto w-fit ${
        !hasSameBgAsSlide ? 'px-6 md:px-8' : ''
      } py-1 rounded-full`}
      style={{
        backgroundColor: backgroundColor,
        fontWeight: bold ? 'bold' : 'normal',
        color: color,
        fontSize: `${fontSize}`,
      }}
    >
      {label}
    </span>
  )
}
